import CookieValue from "./cookie_value";

export default function reqOptions(method, body) {
  return {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + CookieValue(),
    },
    body: body ? JSON.stringify(body) : null,
  };
}
